import React from 'react';

import EgrnPage from '@/features/egrn/pages/egrn.page';

const EgrnRoute = () => {
  return <EgrnPage />;
};

export default EgrnRoute;
